import { ConnectionStatus } from '@epicuro-next/models/users';
import { createAction, props } from '@ngrx/store';

export const initConnectSuccess = createAction(
  '[Connect] Initialize connect success',
);

export const setUserConnectionStatus = createAction(
  '[Connect] Set user connection status',
  props<{ status: ConnectionStatus }>(),
);

export const setVideoLoading = createAction(
  '[Connect] Set the loading status in the state',
  props<{ loading: boolean }>(),
);
